<template>
  <div class="main-page" >
    <div class="head">
        <img src="../assets/zx.png" alt="">
    </div>
    <div class="searchBox">
        <div class="box-l">
            <div @click="goRegion">
                <img src="../assets/address.png" alt="">
                <p>切换城市</p>
            </div>
            
        </div>
        <div class="box-r">
            <div>
                <img src="../assets/search.png" alt="">
                <input type="searchTxt" v-model="searchTxt" @input="iptChange"/>
            </div>
            
        </div>
    </div>
    <div class="radioBox">
        <div class="innerBox">
            <img src="../assets/radio.png" alt="">
            <span>预约体检，请提前三个工作日，门店以实际为准。</span>
        </div>
    </div>
    <div class="content">
        <div class="storeBox" v-for="(item,index) in storeList" :key="index">
            <div class="boxHead">
                <span>{{item.city}}{{item.area}}</span>
                <!-- <span class="areaTxt">{{item.area}}</span> -->
            </div>
            <div class="boxContent">
                <img :src="item.url" alt="" >
                <div class="contentTxt">
                    <div class="title">{{item.name}}</div>
                    <div class="dec">{{item.address}}</div>
                </div>
            </div>
            <div class="boxFoot">
               <img class="star" src="../assets/star.png"/>
                <!-- 营业时间：8:00-10:30am -->
                {{item.time}}
            </div>
        </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '90%' }" >
        <region></region>
    </van-popup>
  </div>
</template>

<script>
import project from '../utils/project'
import store from '../utils/store'
import region from './region'
export default {
    components:{
        region
    },
  data() {
    return {
      address:'',
      userPhone:'',
      userName:'',
      isExChange:false,
      expressNo:'',
      code:'',
      show:true,
      project,
      store,
      searchTxt:'',
      show:false,
      storeList:[]
    };
  },
  
  created() {
    // this.tipsAction()

    console.log(this.project)
    

    console.log(this.store)
    
  },
  mounted (){
      let h = document.documentElement.clientHeight;
      console.log(h)
      let boxH = document.getElementsByClassName("head")[0].clientHeight + document.getElementsByClassName('searchBox')[0].clientHeight + document.getElementsByClassName('radioBox')[0].clientHeight
      console.log(boxH)
      document.getElementsByClassName('content')[0].style.height = h - boxH + 'px'
      let city = localStorage.getItem('cityName');
      if(city){
          localStorage.removeItem('cityName')
          this.searchTxt = city;
          this.storeList = this.store.filter(e => {
              return e.city == city
          })
      }else {
          this.storeList = this.store;
      }
      
  },
  methods: {
    goRegion (){
        this.$router.push('/region')
    },
    iptChange (val){
        console.log(val.target.value)
        if(val.target.value!=''){
            this.storeList = this.store.filter(e => {
                return e.city.indexOf(val.target.value) != '-1'
            })
        }else {
            this.storeList = this.store;
        }
    }
  }
};
</script>

<style scoped lang="scss">
.head {
    padding: 5px 0;
    background: #565555;
    position: relative;
    text-align: left;
    font-size: 0;
    img {
        width: 199px;
        position: relative;
        left: 15px;
    }
}
.searchBox {
    height: 3.4rem;
    overflow:hidden;
    padding: 0 1rem;
    .box-l {
        float: left;
        width: 25%;
        height: 100%;
        position: relative;
        div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 100%;
        }
        img {
            width: 1.2rem;
        }
        p {
            margin: 0;
            font-size: 0.7rem;
            color: #C69C6F;
            width: 100%;
        }
    }
    .box-r {
        width: 75%;
        float: left;
        height: 100%;
        
        div {
            background: #FFFFFF;
            height: 2.6rem;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            overflow: hidden;
            width: 100%;
            border-radius: 0.5rem;
        }
        img {
            width: 1.2rem;
            display: block;
            position: relative;
            z-index: 1;
            top: 50%;
            transform: translateY(-50%);
            left: 0.8rem;
        }
        input {
            height: 100%;
            width: 100%;
            display: block;
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            padding-left: 2.5rem;
            border: none;
        }
    }
}
.radioBox {
    height: 2.6rem;
    padding: 0 1rem;
    text-align: left;
    
    .innerBox {
        height: 2rem;
        line-height: 2rem;
        background: #FFE5E5;
        position: relative;
        padding-left: 2rem;
        font-size: 0.8rem;
        color: #FF8282;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 0.5rem;
        img {
            width: 1rem;
            position: absolute;
            top: 50%;
            left: 0.5rem;
            transform: translateY(-50%);
        }
    }
}
.content {
    width: 100%;
    padding: 0 1rem;
    box-sizing: border-box;
    overflow-y: auto;
}
.storeBox {
    border-radius: 1rem;
    overflow-y: hidden;
    margin-bottom: 0.5rem;
    .boxHead {
        height: 2.6rem;
        line-height: 2.6rem;
        text-align: left;
        background: linear-gradient(180deg, #FFECCC 0%, #FBF0E0 60%, #FFFFFF 100%);
        padding: 0 1rem;
        color: #9E5C17;
        font-size: 0.8rem;
        position: relative;
        .areaTxt {
            position: absolute;
            right: 1rem;
            top: 50%;
            transform: translateY(-50%)
        }
    }
    .boxContent {
        // height: 5rem;
        background: #FFFFFF;
        
        position: relative;
        text-align: left;
        img {
            width: 5rem;
            height: 5rem;
            position: absolute;
            top: 0;
            left: 1rem;
            border-radius: 0.5rem;
        }
        .contentTxt {
            min-height: 5rem;
            padding-left: 6.5rem;
            top: 0;
            width: 100%;
            box-sizing: border-box;
            .title {
                color: #333333;
                font-weight: bold;
                font-size: 1rem;
                padding-right: 1rem;
            }
            .dec {
                font-size: 0.8rem;
                color: #747474;
                margin-top: 0.6rem;
                padding-right: 1rem;
            }
        }
    }
    .boxFoot {
        height: 1.6rem;
        line-height: 1.6rem;
        color: #875F36;
        font-size: 0.6rem;
        background: #FFFFFF;
        text-align: left;
        padding-left: 7.8rem;
        position: relative;
        .star {
            height: 1rem;
            width: 1rem;
            vertical-align: middle;
            position: absolute;
            top: 50%;
            left: 6.5rem;
            transform: translateY(-60%);
        }
    }

}



</style>
